import { DriverFormValues } from "_interfaces/driver.interfaces";
import Input from "components/input";
import PhoneInput from "components/input/phone-input";
import Select from "components/select";
import { NamespaceKeys } from "locale/types";
import { Controller, UseFormReturn } from "react-hook-form";

interface DriverEmergencyTabProps {
  form: UseFormReturn<any>;
  t: (key: NamespaceKeys<"driver">, options?: Record<string, unknown>) => string;
}

const DriverEmergencyTab = ({
  form,
  t,
}: DriverEmergencyTabProps) => {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <div className="grid grid-cols-2 gap-6">
      <Input
        label={t("label-emergency-contact-name")}
        required
        placeholder={t("placeholder-name")}
        {...register("emergencyName")}
        error={errors.emergencyName as any}
      />

      <Controller
        name="emergencyRelation"
        control={form.control}
        render={({ field, fieldState }) => (
          <Select
            label={t("label-relation")}
            required
            options={[
              { label: t("relation-mother"), value: "Mother" },
              { label: t("relation-father"), value: "Father" },
              { label: t("relation-spouse"), value: "Spouse" },
              { label: t("relation-son"), value: "Son" },
              { label: t("relation-daughter"), value: "Daughter" },
              { label: t("relation-friend"), value: "Friend" },
            ]}
            value={field.value}
            onValueChange={(value) => field.onChange(value)}
            error={fieldState.error}
            placeholder={t("placeholder-select")}
          />
        )}
      />

      <div className="col-span-2">
        <Controller
          name="emergencyPhoneNumber"
          control={form.control}
          render={({ field, fieldState }) => (
            <PhoneInput
              label={t("label-phone-number")}
              required
              value={field.value}
              onChange={(event) => field.onChange(event.target.value)}
              countryCode={form.watch("emergencyPhoneCountryCode")}
              onCountryChange={(code) => form.setValue("emergencyPhoneCountryCode", code)}
              placeholder={t("placeholder-driver-phone")}
              error={fieldState.error}
            />
          )}
        />
      </div>
    </div>
  );
};

export default DriverEmergencyTab;
